import { html } from 'lit';
const FruitPanel =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' d="m9.59 2.7-.591-.31-.62 1.181.59.31c.766.402 1.296.878 1.663 1.444q.301.463.482 1.056c-2.335-.678-4.16-.21-5.395 1.074-1.366 1.418-1.842 3.668-1.693 5.82.149 2.166.939 4.41 2.323 5.894.7.749 1.563 1.315 2.579 1.554.945.223 1.978.15 3.07-.263 1.094.414 2.127.486 3.073.263 1.016-.239 1.88-.805 2.579-1.554 1.385-1.483 2.175-3.728 2.324-5.893.148-2.153-.328-4.403-1.694-5.82-1.299-1.35-3.249-1.799-5.759-.962a5.7 5.7 0 0 0-.77-1.894c-.512-.788-1.228-1.41-2.162-1.9"/>
  </svg>
`;
export default FruitPanel;
